var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bizcomp-reset-lpwd"},[_c('reset-pwd',{attrs:{"way":_vm.way}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }